import { common } from './common'

export const production = {
    ...common
}